import { createContext } from 'react'

interface DesktopNavigationContextType {
  hideTooltips: boolean
}

export const DesktopNavigationContext = createContext<DesktopNavigationContextType>({
  hideTooltips: false,
})
